import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const TourTime = styled.div`
  color: ${colors.whaleGrey};

  span {
    visibility: hidden;
  }
`;

TourTime.displayName = "TourTime";

export { TourTime };
